<template>
    <div class="container-fluid bg-login">
      <div class="bg-banner">
        <div style="position: absolute; top: 20px; left: 20px">
          <LanguageIcons />
        </div>
        <div class="login" style="padding-top: 25vh;">
          <div class="loginblock">
            <div class="head">
              <h1>
                {{ $t('login.forgot_password') }}
                <a class="back-button" @click="$router.back();">
                  <span class="icon icon-arrow-long-left"></span>
                </a>
              </h1>
            </div>
            <div class="content">
              <form id="form-forgot">
                <div>
                  <div v-if="sentMail">
                    <span class="icon icon-email"></span>
                    <p class="title">{{ $t('login.email_sent') }}</p>
                    <p>{{ $t('login.password_reset_instructions') }}</p>
                    <p><i>{{ $t('login.email_validity') }}</i></p>
                  </div>
                  <div v-else class="fields">
                    <div class="field">
                      <input name="email" type="email"
                             :placeholder="$t('login.email')"
                             v-model="email" id="email">
                    </div>
                    <div class="field buttonfield">
                    <button class="big" id="send-pass" :disabled="loading" @click="postPasswordForgot">
                      {{ $t('login.reset_password') }}
                    </button>
                  </div>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Auth from '@/api/auth';
import axios from '@/plugins/axios';
import LanguageIcons from '@/components/Layout/LanguageIcons.vue';

export default {
  name: 'login',
  components: { LanguageIcons },
  data() {
    return {
      email: '',
      loading: false,
      sentMail: false,
    };
  },
  methods: {
    resetStoredData() {
      localStorage.removeItem('tenant_id');
      localStorage.removeItem('network_id');
      axios.defaults.headers['x-tenant'] = null;
      axios.defaults.headers['x-network'] = null;
    },
    postPasswordForgot() {
      this.resetStoredData();
      this.loading = true;
      Auth.sendPasswordResetMail(this.email)
        .then(() => {
          this.sentMail = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  beforeMount() {
    this.$emit('showFullscreen', true);
  },
};
</script>

<style scoped>
    .bg-login {
        background-image: url('../../assets/img/bg.png');
        height: 100vh;
        max-height: 100vh;
        overflow: hidden;
    }

    .bg-banner {
      background: url('../../assets/img/banner.svg') no-repeat;
      background-size: 100% auto;
    }
</style>
